module.exports = __webpack_public_path__ + "img/20190709164358280.e77c670d.png";